export const TimelineDot = ({ n }: { n: number }) => (
  <div className="w-6 h-6 bg-gray-500 text-white rounded-full flex justify-center items-center text-[14px]">
    {n}
  </div>
);
